export default "__VITE_ASSET__COTYQI2F__"